module.exports = __webpack_public_path__ + "img/voideBg1.0203646b.jpg";